export default {
  configuration: {
    dialog: {
      header: 'Aviso!',
      unnamedClassification: 'sem nome',
      save:
        'Salvar todos os dados?<br><br>' +
        '<strong>Atenção:</strong> as classificações são regravadas por completo. ' +
        'Qualquer classificação que você removeu desta tela deixa de existir e as gestões já ' +
        'encerradas que a utilizavam perdem o vínculo com ela, passando a aparecer zeradas.<br>' +
        'Não há como desfazer depois de salvar.',
      undo: 'Desfazer todos os dados não salvos?',
      restoreDefault:
        'Restaurar todas as classificações para as padrões?<br><br>' +
        '<strong>Atenção - esta ação apaga dados:</strong> todas as classificações e coleções ' +
        'configuradas são excluídas e as padrões são recriadas com novos identificadores. ' +
        'As gestões já encerradas perdem o vínculo com as classificações e passam a aparecer ' +
        'zeradas.<br>' +
        'Não há como desfazer após a ação.',
      removeClassification:
        'Remover a classificação "{name}"?<br><br>' +
        'Ao salvar, ela deixa de existir e as gestões já encerradas que a utilizavam perdem o ' +
        'vínculo com ela, passando a aparecer zeradas.',
    },
  },
};
